<div class="content">
  <ng-container *ngIf="isVideo; else image">
    <video [src]="data.viewerUrl" class="content-video" controls autoplay></video>
  </ng-container>
  <ng-template #image>
    <img [src]="data.viewerUrl" [alt]="" class="content-image">
  </ng-template>
</div>